import script from "./AdminWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminWidget.vue?vue&type=script&setup=true&lang=js"

import "./AdminWidget.vue?vue&type=style&index=0&id=e1f2385e&lang=css"

const __exports__ = script;

export default __exports__